<div class="notification has-text-centered" *ngIf="showStrip">
    <p><strong>{{ statusType }}</strong> - {{ statusMessage }} <a class="has-text-weight-bold has-text-info" style="text-decoration: none;" href="https://status.campfirebot.xyz">System Status ></a></p>
</div>